<template>
  <Block
    :title="dailyTargetTitle"
    subtitle="Objectif du jour"
    :emoji="isCompleted ? '✅' : '🎯'"
    :badge-class="isCompleted ? 'bg-green-100' : 'bg-purple-50'"
  />
</template>

<script>
import { Block } from "@estaly/ui";

export default {
  components: {
    Block,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    target: {
      type: Number,
      required: true,
    },
    leadsWaiting: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    dailyTargetTitle() {
      return `Faire ${this.$t("roadmap.sales", this.target)} aujourd'hui`;
    },
    isCompleted() {
      return this.current + this.leadsWaiting >= this.target;
    },
  },
};
</script>
